/**
 * The starter chips (spec 006 FR-A05).
 *
 * ⚠ **Six, hard-coded, each one a shape the pipeline demonstrably covers** — one per tier and per
 * entity family. A chip the pipeline cannot answer is worse than no chips at all, because it
 * teaches the reader the wrong mental model on their very first turn, and first impressions of a
 * tool like this are hard to revise.
 */
export const STARTER_CHIPS: readonly string[] = Object.freeze([
  // Tier 1, jobs, three axes at once.
  'Give me 10 target jobs in R1 that are allied',
  // Tier 0/1 measure with a dashboard twin — shows the reconciliation line.
  'How many jobs are open in R3?',
  // Submissions over a window.
  'How many submissions went out last quarter?',
  // A series, so the partial-bucket mark is visible early.
  'How have submissions moved by month this year?',
  // Placements as a stock — the ACTIVE trap, answered correctly.
  'How many candidates are active right now?',
  // Definitional: no query runs, and the answer cites the PRD.
  'What does Internal mean?',
]);
